import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import InvDetailRouteEditor from "./InvDetailRouteEditor";
import DocAttribute from "../../cmn/docAttribute/DocAttribute";
import FormDialog from '../../../library/form/components/FormDialog';
import FormTitle from '../../../library/form/components/FormTitle'
import { UiView, UiViewContent, UiForm, UiGridColTwo, UiCol } from "../../../library/layout/Index";

const InvRouteEditorSH = (props) => {
    const { formObject, viewMap, viewData, ...restProps } = props;
    const [open, setOpen] = React.useState(true);

    const closeModel = () => {
        setOpen(false);
        restProps.onDynamicViewClose();
    }

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={open}
            formStyle={{ width: '740px' }}
            contentStyle={{ height: '460px' }}
            formTitle={<FormTitle formObject={formObject} value='Ticket Detail' />}
            formObject={formObject} >
            <UiView>
                <UiViewContent>
                    <UiGridColTwo>
                        <UiCol>
                            <UiForm formName="InvDetail">
                                <InvDetailRouteEditor viewMap={viewMap} closeModel={closeModel} viewData={viewData.childViews.invDetails} />
                            </UiForm>
                        </UiCol>
                        <UiCol>
                            <UiForm formName="TicketInfo">
                                <div style={{height:"400px", overflow:"auto"}} >
                                    <DocAttribute viewMap={viewMap} viewData={viewData.childViews.ticketInfo} />
                                </div>
                            </UiForm>
                        </UiCol>
                    </UiGridColTwo>
                </UiViewContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(InvRouteEditorSH, "invRouteComp")